import { DASHBOARD_ROLES } from "@/pages/home/components/role-dashboard/types/dashboard-role.types";
import { APP_ROUTES_TO } from "@/utils/routes";

import type { RoleSidebarPathsByRole } from "../types/sidebar-role.types";

export const ROLE_SIDEBAR_PATHS: RoleSidebarPathsByRole = {
    [DASHBOARD_ROLES.SETTING_AGENT]: [
        APP_ROUTES_TO.ROOT,
        APP_ROUTES_TO.CALLS,
        APP_ROUTES_TO.LISTS,
        APP_ROUTES_TO.PERFORMANCE_KPIS,
    ],
    [DASHBOARD_ROLES.CSO]: [
        APP_ROUTES_TO.ROOT,
        APP_ROUTES_TO.CALLS,
        APP_ROUTES_TO.PERFORMANCE_KPIS,
        APP_ROUTES_TO.PERFORMANCE_REPORTS,
    ],
    [DASHBOARD_ROLES.CMO]: [
        APP_ROUTES_TO.ROOT,
        APP_ROUTES_TO.CALLS,
        APP_ROUTES_TO.PERFORMANCE_KPIS,
        APP_ROUTES_TO.PERFORMANCE_REPORTS,
    ],
};
